const VA_VERSION_PATTERN = /^(LX-)?VA-(\d+\.\d+\.\d+\.\d+)(-[A-Za-z0-9.]+)?$/

export const VaVersions = {
    'VA-15.1.0.2': parseVaVersion('VA-15.1.0.2')!,
    'VA-16.4.0.0': parseVaVersion('VA-16.4.0.0')!,
    'VA-20.2.0.2': parseVaVersion('VA-20.2.0.2')!,
    'LX-VA-20.2.0.1-EdgeLink.0': parseVaVersion('LX-VA-20.2.0.1-EdgeLink.0')!,
} as const

export function vaVersionIsGreaterOrEqual(vaVersion: ParsedVaVersion | undefined, referenceVersion: ParsedVaVersion) {
    if (!vaVersion) {
        return false
    }

    try {
        const comp = compareVaVersions(vaVersion, referenceVersion)
        return comp >= 0
    } catch {
        return false
    }
}

function compareVaVersions(v1: ParsedVaVersion, v2: ParsedVaVersion) {
    const diff = v1.number - v2.number
    return Math.min(Math.max(diff, -1), 1)
}

interface ParsedVaVersion {
    number: number
    lx: boolean
    suffix?: string
}

export function parseVaVersion(vaVersionString?: string): ParsedVaVersion | undefined {
    if (!vaVersionString || typeof vaVersionString !== 'string') {
        return undefined
    }

    const match = vaVersionString.match(VA_VERSION_PATTERN)
    if (!match) return undefined

    const isLX = match[1] === 'LX-'
    const numbers = match[2].split('.').map((n) => parseInt(n, 10))
    const suffix = match[3] ? match[3].replace(/^-/, '') : undefined

    const versionNumber = numbers.reverse().reduce((ack, cur, i) => {
        return ack + Math.pow(10, 3 * i) * cur
    })
    return { number: versionNumber, lx: isLX, suffix }
}

export function vaVersionSupportsAdaptiveFec(vaVersionString?: string) {
    return vaVersionString && vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), VaVersions['VA-15.1.0.2'])
}
export function vaVersionSupports12MTimeCode(vaVersionString?: string) {
    return vaVersionString && vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), VaVersions['VA-16.4.0.0'])
}

export function vaVersionSupportsEdgeLink(vaVersionString?: string) {
    const version = parseVaVersion(vaVersionString)
    if (!version) return false

    return (
        vaVersionIsGreaterOrEqual(parseVaVersion(vaVersionString), VaVersions['VA-20.2.0.2']) ||
        (version.lx && version.suffix?.startsWith('EdgeLink'))
    )
}
